const replaceAll = (
  originalString: string,
  search: string | RegExp,
  replacement: string
): string => {
  const target = originalString;
  return target.replace(new RegExp(search, "g"), replacement);
};

export default replaceAll;
